import React from "react";
import { Modal, notification } from "antd";
import FinDocListPage from "../components/FinDocListPage";
import { cancelFinDoc, queryFinDoc } from "../newApi/findoc.api";

const ACTIVE_STATUSES = ["pendingAudit", "pendingMgr", "pendingFinance"];

export default function FinDocApplication() {
  return (
    <FinDocListPage
      title="我的申請"
      menuKey="FinDocApplication"
      defaultStatuses={ACTIVE_STATUSES}
      fetcher={queryFinDoc}
      addPath="/FinDoc/Add"
      getActions={(record, actor, navigate) => {
        const actions = [
          {
            label: "檢視",
            onClick: () => navigate(`/FinDoc/View/${record.findoc_no}`),
          },
        ];

        const canCancel = [record.applicant_mail, record.agent_mail].filter(Boolean).map((item) => item.toLowerCase()).includes(String(actor.email).toLowerCase()) && record.findoc_status !== "done";
        if (canCancel) {
          actions.push({
            label: "取消",
            danger: true,
            onClick: () => {
              Modal.confirm({
                title: `確認取消 FD-${record.findoc_no}？`,
                onOk: async () => {
                  const resp = await cancelFinDoc(record.findoc_no);
                  if (resp?.isSuccess !== false) {
                    notification.success({ message: "成功", description: `FD-${record.findoc_no} 已取消` });
                    window.location.reload();
                  }
                },
              });
            },
          });
        }

        return actions;
      }}
    />
  );
}